<template>
  <!-- 合作案例 -->
  <div class="index-model-5">
    <div
      style="width: 100%; height: 291px; text-align: center; background-size: 100%; line-height: 175px"
      :style="{ backgroundImage: `url(${ImageBg})` }"
    >
      <span style="font-size: 30px;" class="white--text">合作案例</span>
    </div>
    <div
      style="margin-left: auto; margin-right: auto;"
      :style="{
        width: wrapWidth < 1376 ? '90%' : '75%'
      }"
    >
      <div style="width: 100%; min-height: 923px; position: relative;">
        <div id="im5-1" class="white" style="position: absolute; top: -140px">
          <canvas id="im5-1-canvas" width="1619" height="923" style="width: 100%"/>
        </div>
      </div>

      <!-- 案例一：基于知识图谱的糖尿病营养膳食管理工具 -->
      <div>
        <div class="d-flex align-center">
          <div class="pr-3">
            <v-img :src="ImageIcon1" contain width="37"></v-img>
          </div>
          <span style="font-size: 20px">案例一：新生儿遗传代谢病早筛系统</span>
        </div>
        <div style="margin-top: 97px" class="d-flex justify-space-between">
          <div
            v-for="al1Item in al1"
            :key="al1Item.id"
            style="width: 19%; "
            class="pa-3"
          >
            <v-img :src="al1Item.image"></v-img>
            <v-img
              :src="al1Item.titleImage"
              width="49px"
              height="43px"
              style="margin: auto"
              class="mt-11 mb-9"
            />
            <div class="text-center" style="white-space: break-spaces;color: #656A72">{{ al1Item.content }}</div>
          </div>
        </div>
      </div>
      <!-- 案例二：基于智能决策引擎的血糖动态监测指标解读与改善建议 -->
      <div id="im5-al2">
        <div class="d-flex align-center">
          <div class="pr-3">
            <v-img :src="ImageIcon1" contain width="37"></v-img>
          </div>
          <span style="font-size: 20px;color: #333">案例二：基于智能决策引擎的血糖动态监测指标解读与改善建议</span>
        </div>
        <div style="margin-top: 90px" class="px-8">
          <div class="im5-al2-card-title">生成报告--报告解读-日趋势图</div>
          <div style="margin-top: 68px">
            <v-img :src="ImageAL1" contain/>
          </div>
        </div>
        <div class="im5-al2-card px-8">
          <div class="im5-al2-card-title">生成报告--问题分析与改善建议</div>
          <div class="im5-al2-card-content">
            <v-row class="ma-0">
              <v-col :cols="8" class="pl-0">
                <div v-for="al2Item in al2.left" :key="al2Item.id">
                  <div class="im5cc-left-title px-4">{{ al2Item.title }}</div>
                  <div class="py-4">
                    <template v-for="al2cItem in al2Item.content">
                      <div :key="al2cItem.id" class="d-flex im5cc-left-content">
                        <div class="px-4" style="width: 30%;">{{ al2cItem.title }}</div>
                        <div class="px-2"/>
                        <div class="px-4 pb-3" style="width: 70%;background-color: #F7F7F7">{{ al2cItem.text }}</div>
                      </div>
                    </template>
                  </div>
                </div>
              </v-col>
              <v-col :cols="4">
                <div class="im5cc-left-title px-4" style="background-color: transparent;color: #24344B;">问题分析与改善建议</div>
                <ul class="py-4" style="color: #656A72">
                  <li style="line-height: 32px; margin-bottom: 45px">
                    通过数据分析，识别出“低血糖风险”“血糖波动”“体重偏轻”等风险事件，依据《共识》给出改善建议。结合整体情况，给出饮食建议、运动建议。
                  </li>
                  <li style="line-height: 32px">结合整体情况，给出饮食建议、运动建议。</li>
                </ul>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
      <!-- 案例三：智能决策助力数字化健康险业务全流程 -->
      <div id="im5-al3">
        <div class="d-flex align-center">
          <div class="pr-3">
            <v-img :src="ImageIcon1" contain width="37"></v-img>
          </div>
          <span style="font-size: 20px;color: #333">案例三：智能决策助力数字化健康险业务全流程</span>
        </div>
        <div style="margin-top: 90px" class="px-8">
          <v-row class="ma-0">
            <v-col cols="4" class="d-flex flex-column justify-space-around">
              <div
                v-for="al3Item in al3"
                :key="al3Item.id"
                style="cursor: default;"
                class="im5-al3-title"
                :class="{'im5-al3-title-hover': al3Image === al3Item.image}"
                @mouseenter="al3Image = al3Item.image"
              >
                <div v-show="al3Image === al3Item.image" class="im5-al3-hr"/>
                <div style="font-size: 18px; ">step{{ al3Item.id }}</div>
                <div style="font-size: 20px; width: 160px">{{ al3Item.text }}</div>
              </div>
            </v-col>
            <v-col cols="8">
              <div style="min-height:100px; max-height: 796px; width: 100%; ">
                <v-img :src="al3Image"/>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageBg from '../../../../assets/pc/index/dss/合作案例-背景.png'
import ImageNeed from '../../../../assets/pc/index/dss/需求背景.png'
import ImageGH from '../../../../assets/pc/index/dss/项目规划-背景.png'
import ImageLH from '../../../../assets/pc/index/dss/立项报告.png'
import ImageIcon1 from '../../../../assets/pc/index/dss/组 23.png'
import ImageIphone1 from '../../../../assets/pc/index/dss/iphone-左1.png'
import ImageIphone2 from '../../../../assets/pc/index/dss/iphone-左2.png'
import ImageIphone3 from '../../../../assets/pc/index/dss/iphone-左3.png'
import ImageIphone4 from '../../../../assets/pc/index/dss/iphone-左4.png'
import ImageIphone5 from '../../../../assets/pc/index/dss/iphone-左5.png'
import ImageXT from '../../../../assets/pc/index/dss/血糖水平的实时监控 .png'
import ImageMR from '../../../../assets/pc/index/dss/每日食物摄入量 总情况跟踪.png'
import ImageTS from '../../../../assets/pc/index/dss/提示规则触发(摄入量提示_检测提示_血糖值监测) .png'
import ImageZN from '../../../../assets/pc/index/dss/智能食谱推荐_ 功能性食品推荐 .png'
import ImageJK from '../../../../assets/pc/index/dss/健康教育 .png'
import ImageAL1 from '../../../../assets/pc/index/dss/1.png'
// # 案例 3
import ImageAl35 from '../../../../assets/pc/index/dss/im5-al3-5.png'
import ImageAl31 from '../../../../assets/pc/index/dss/案例3-2.png'
import ImageAl32 from '../../../../assets/pc/index/dss/案例3-3.png'
import ImageAl33 from '../../../../assets/pc/index/dss/案例3-4.png'
import ImageAl34 from '../../../../assets/pc/index/dss/案例3-1.png'

import DssCard from './dss-card.vue'

const rectRoundPromise = (image, x, y, order) => new Promise(resolve => {
  const canvas = document.getElementById('im5-1-canvas')
  const ctx = canvas.getContext('2d')
  // # 项目规划方块图片
  const imageDOM = new Image()
  imageDOM.src = image
  if (order === 1) {
    imageDOM.width = 108
    imageDOM.height = 61
  }
  imageDOM.onload = () => {
    ctx.drawImage(imageDOM, x, y)
    resolve()
  }
})
// # 需求背景(ImageNeed)：{ x: 122 y: 69 }
const needPromise = (x, y) => rectRoundPromise(ImageNeed, x, y, 1)
// # 项目规划图(ImageGH)：{ x: 127 y: 85 }
const ghPromise = (x, y) => rectRoundPromise(ImageGH, x, y, 2)
// # 立项报告图(ImageLH)：{ x: 90 y: 100 }
const lHPromise = (x, y) => rectRoundPromise(ImageLH, x, y, 3)

export default {
  name: 'cooperation-case',
  props: {
    wrapWidth: {
      type: Number,
      default: 0
    }
  },
  components: { DssCard },
  data () {
    return {
      ImageBg,
      ImageIcon1,
      ImageAL1,
      ImageAl35,

      // # 案例 1
      al1: [
        { id: 1, image: ImageIphone1, titleImage: ImageXT, content: '血糖水平的实时监控' },
        { id: 2, image: ImageIphone2, titleImage: ImageMR, content: '每日食物摄入量\n总情况跟踪' },
        {
          id: 3,
          image: ImageIphone3,
          titleImage: ImageTS,
          content: '提示规则触发     \n (摄入量提示/检测提示/血糖值监测)\n'
        },
        { id: 4, image: ImageIphone4, titleImage: ImageZN, content: '智能食谱推荐/\n功能性食品推荐\n' },
        { id: 5, image: ImageIphone5, titleImage: ImageJK, content: '健康内容' }
      ],
      // # 案例 2
      al2: {
        left: [
          {
            id: 1,
            title: '目前需要关注的问题',
            content: [
              { id: 1, title: '问题 1', text: '低血糖风险' },
              { id: 2, title: '危害/风险', text: '严重低血糖会出现神志不清，甚至昏迷危及生命。' },
              {
                id: 3,
                title: '改善建议',
                text: '1.改善饮食结构，调整进餐时间，增加蛋白质摄入，控制高热量食物摄入，少吃多餐；2.在专科医生指导下调整胰岛素剂量；3.注意监测血糖；4.随身携带糖果、饼干，遇到心慌、浑身冷汗、饥饿感等低血糖症状时，及时食用，以应对突发低血糖。'
              }
            ]
          },
          {
            id: 2,
            title: '目前需要关注的问题',
            content: [
              { id: 1, title: '问题 2', text: '血糖波动' },
              {
                id: 2,
                title: '危害/风险',
                text: '血糖波动频繁说明患者的病情没有得到满意的控制，会加重病情，加重动脉粥样硬化，导致大血管或微血管出现慢性并发症。血糖波动是糖尿病并发症发生发展的重要原因。'
              },
              {
                id: 3,
                title: '改善建议',
                text: '1.三餐适当控制餐量，尽量少馒头、膨化食品、炸糕等容易升高血糖的食物；少吃多餐，调整用餐时间，避免低血糖的情况出现；2.适当运动，例如慢跑、快步走等，利于降低餐后血糖；3.建议夜间尽量减少进食，以避免夜间血糖偏高；4.建议内分泌专科就诊，是否需要调整胰岛素剂量。'
              }
            ]
          },
          {
            id: 3,
            title: '目前需要关注的问题',
            content: [
              { id: 1, title: '问题 3', text: '视网膜轻微出血' },
              { id: 2, title: '危害/风险', text: '严重视网膜出血可导致视网膜剥脱甚至失明。' },
              {
                id: 3,
                title: '改善建议',
                text: '努力将血糖控制好，保持血糖平稳，延缓并发症的进展；定期到医院眼科复查；注意休息，不要长时间看书、看报、看电视，避免过度兴奋和疲劳，保持良好和充足的睡眠。不要吃刺激性食物，禁喝咖啡和浓茶。'
              }
            ]
          }
        ]
      },
      // # 案例 3
      al3: [
        { id: 1, text: '智能理赔客户端', image: ImageAl34 },
        { id: 2, text: '智能录入', image: ImageAl31 },
        { id: 3, text: '智能核赔', image: ImageAl32 },
        { id: 4, text: '智能辅助作业系统', image: ImageAl33 }
      ],
      al3Image: ImageAl34
    }
  },
  methods: {
    handleCanvas () {
      const canvas = document.getElementById('im5-1-canvas')
      const ctx = canvas.getContext('2d')
      // 画之前先擦拭掉
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight)
      ctx.strokeStyle = '#0084E0'
      ctx.lineWidth = 3
      ctx.save()// 画之前保存之前的状态

      this.handleCanvasLeft(ctx)
      this.handleCanvasCanvas(ctx)

      // # 底部
      ctx.setLineDash([10])
      ctx.rect(645, 749, 555, 80)
      ctx.stroke()
      // # 底部文本：基于DSS科研工具平台提供服务
      ctx.font = 'bold 16px 思源黑体'
      ctx.strokeStyle = '#0084E0'
      ctx.fillText('基于智能决策引擎平台提供服务', 800, 795)
    },
    handleCanvasLeft (ctx) {
      ctx.font = 'bold 16px 思源黑体'
      ctx.fillStyle = '#2196f3'
      ctx.fillText('客户', 259, 105)

      // # 左侧：需求
      needPromise(344, 63).then(_ => {
        ctx.font = '16px 思源黑体'
        ctx.fillStyle = 'white'
        ctx.fillText('需求', 390, 105)
      })
      // # 左侧：需求向下直线到数据准备
      ctx.beginPath()
      ctx.moveTo(407.5, 130)
      ctx.lineTo(407.5, 500)
      ctx.stroke()
      ctx.closePath()
      // # 左侧：项目规划
      ghPromise(344, 205).then(_ => {
        ctx.font = '16px 思源黑体'
        ctx.fillText('项目', 389, 242)
        ctx.fillText('规划', 389, 269)
      })
      // # 左侧：立项报告
      ghPromise(344, 320).then(_ => {
        ctx.font = '16px 思源黑体'
        ctx.fillText('立项', 389, 359)
        ctx.fillText('报告', 389, 384)
      })
      // # 左侧：数据准备
      ghPromise(344, 435).then(_ => {
        ctx.font = '16px 思源黑体'
        ctx.fillText('数据', 389, 472)
        ctx.fillText('准备', 389, 499)
      })
      // # 左侧：成果转化
      ghPromise(344, 585).then(_ => {
        ctx.font = '16px 思源黑体'
        ctx.fillText('成果', 389, 622)
        ctx.fillText('转化', 389, 649)
      })
      // # 左侧：绘制矩形框 { x: 192; y: 591 }
      ctx.beginPath()
      ctx.rect(303, 165, 201, 591)
      ctx.strokeStyle = '#0084E0'
      ctx.stroke()
      ctx.closePath()
      // # 左侧：合作部分：距矩形底部 74
      ctx.beginPath()
      ctx.moveTo(303, 692)
      ctx.lineTo(503, 692)
      ctx.stroke()
      ctx.closePath()
      // # 左侧：合作部分：文本
      ctx.font = 'bold 16px 思源黑体'
      ctx.fillText('合作部分', 372, 732)
    },
    handleCanvasCanvas (ctx) {
      // # 右侧-上：立项报告
      lHPromise(632, 229).then(_ => {
        ctx.font = '16px 思源黑体'
        ctx.fillText('立项', 660, 274)
        ctx.fillText('报告', 660, 300)
      })
      // # 右侧-中：线条 { x: 1056, y: 150 }
      ctx.beginPath()
      ctx.moveTo(344, 477.5)
      ctx.lineTo(1451, 477.5)
      ctx.lineTo(1451, 627.5)
      ctx.lineTo(344, 627.5)
      ctx.strokeStyle = '#0084E0'
      ctx.stroke()
      ctx.closePath()
      ctx.beginPath()
      ctx.moveTo(1292, 477.5)
      ctx.lineTo(1292, 627.5)
      ctx.strokeStyle = '#0084E0'
      ctx.stroke()
      ctx.closePath()
      // # 右侧-中：数愈可提供的部分
      ctx.font = 'bold 16px 思源黑体'
      ctx.fillText('数愈可提', 1339.5, 547)
      ctx.fillText('供的部分', 1339.5, 573)
      // # 右侧-中：虚线矩形 - 1
      ctx.beginPath()
      ctx.moveTo(677, 349)
      ctx.lineTo(677, 552)
      ctx.lineTo(1140, 552)
      ctx.lineTo(1140, 349)
      ctx.lineTo(1047, 349)
      ctx.setLineDash([10])
      ctx.stroke()
      ctx.closePath()
      ctx.beginPath()
      ctx.moveTo(677, 349)
      ctx.lineTo(770, 349)
      ctx.stroke()
      ctx.closePath()
      // # 右侧-中：虚线矩形 - 2
      ctx.beginPath()
      ctx.moveTo(778, 309)
      ctx.lineTo(1047, 309)
      ctx.lineTo(1047, 387)
      ctx.lineTo(778, 387)
      ctx.lineTo(778, 309)
      ctx.setLineDash([10])
      ctx.fillStyle = '#0084E0'
      ctx.stroke()
      ctx.closePath()
      // # 右侧-中：虚线矩形 - 2 - 文本：研发周期可控1-3个月
      ctx.font = 'bold 16px 思源黑体'
      ctx.strokeStyle = '#0084E0'
      ctx.fillText('研发周期可控1-3个月', 840, 356)
      // # 右侧-中：数据处理
      lHPromise(632, 431).then(_ => {
        ctx.font = '16px 思源黑体'
        ctx.fillText('数据', 660, 477)
        ctx.fillText('处理', 660, 503)
      })
      // # 右侧-中：规则配置
      lHPromise(860, 431).then(_ => {
        ctx.font = '16px 思源黑体'
        ctx.fillText('规则', 888, 477)
        ctx.fillText('配置', 888, 503)
      })
      // # 右侧-中：应用配置
      lHPromise(1092, 431).then(_ => {
        ctx.font = '16px 思源黑体'
        ctx.fillText('应用', 1119, 477)
        ctx.fillText('配置', 1119, 503)
      })
      // # 右侧-下：市场推广
      lHPromise(632, 569).then(_ => {
        ctx.font = '16px 思源黑体'
        ctx.fillText('市场', 660, 615)
        ctx.fillText('推广', 660, 640)
      })
      // # 右侧-下：应用验证
      lHPromise(860, 569).then(_ => {
        ctx.font = '16px 思源黑体'
        ctx.fillText('应用', 888, 615)
        ctx.fillText('验证', 888, 640)
      })
      // # 右侧-下：实施部署
      lHPromise(1092, 569).then(_ => {
        ctx.font = '16px 思源黑体'
        ctx.fillText('实施', 1119, 615)
        ctx.fillText('部署', 1119, 640)
      })
    }
  },
  mounted () {
    this.handleCanvas()
  }
}
</script>

<style scoped>
/* index model 5 - 案例 2 */
#im5-al2 {
  margin-top: 120px;
}

.im5-al2-card {
  margin-top: 90px
}

.im5-al2-card-title {
  font-size: 16px;
  color: #333
}

.im5-al2-card-content {
  margin-top: 68px
}

/* im5cc: index model 5 card content */
.im5cc-left-title {
  font-size: 18px;
  background-color: #D5DDF0;
}

.im5cc-left-content {
  min-height: 32px;
  line-height: 32px
}

.im5cc-left-content div {
  background-color: #F7F7F7
}

.im5cc-left-content > div:first-child {
  width: 30%
}

.im5cc-left-content > div:nth-child(2) {
  background-color: transparent
}

.im5cc-left-content > div:last-child {
  width: 70%
}

/* index model 5 - 案例 3 */
#im5-al3 {
  margin-top: 120px;
  margin-bottom: 120px
}

.im5-al3-title {
  height: 50px;
  font-size: 16px;
  position: relative;
  transition: left 0.5s ease;
  left: 30px;
}

.im5-al3-title-hover {
  left: -13px;
  color: #376AFF;
}

.im5-al3-hr {
  position: absolute;
  top: 18px;
  left: -24px;
  height: 30px;
  background-color: #376AFF;
  width: 4px
}

.im5-al3-image {
  width: 80%;
  height: 100%;
  background-position: center;
  margin-left: 140px;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/pc/home/dss/cooperation-case.vue